import { useState } from "react";
import { useReveal } from "../hooks/useReveal";

/** Display with light grouping; clipboard uses digits only. */
const MOMO_DISPLAY = "0779 809 343";
const MOMO_DIGITS = "0779809343";
const MOMO_TEL = "+256779809343";

export function GivePage() {
  const ref = useReveal<HTMLElement>();
  const [copied, setCopied] = useState(false);

  async function copyNumber() {
    try {
      await navigator.clipboard.writeText(MOMO_DIGITS);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard may be unavailable; number remains visible + tel: link */
    }
  }

  return (
    <section className="section section-give" ref={ref}>
      <div className="give-inner">
        <div className="sec-eyebrow">
          <em>Give</em>
        </div>
        <h1 className="sec-title">Support the ministry</h1>
        <p className="lede-serif" style={{ maxWidth: 640 }}>
          Together In Heaven is a worship ministry in Kampala. Your gift helps
          cover the worship overnights — venue, sound, and the practical costs
          of gathering. Thank you for standing with us.
        </p>

        <div className="give-methods">
          <div className="give-card give-card-feat">
            <div className="give-card-k">MTN Mobile Money</div>
            <a className="give-number" href={`tel:${MOMO_TEL}`}>
              {MOMO_DISPLAY}
            </a>
            <p className="give-card-note">
              Send MoMo to this number. You may put your name in the reason —
              we will know it is for the ministry.
            </p>
            <div className="give-actions">
              <button type="button" className="btn btn-primary" onClick={copyNumber}>
                {copied ? "Copied" : "Copy number"}
              </button>
              <a className="btn btn-ghost" href={`tel:${MOMO_TEL}`}>
                Open dialer
              </a>
            </div>
          </div>

          <div className="give-card">
            <div className="give-card-k">Cash at the events</div>
            <div className="give-card-v">Worship overnights</div>
            <p className="give-card-note">
              You can also give in cash when we gather. Look for the team
              receiving the offering.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
